import {
    SET_ESS_KW,
    SET_ESS_KWH,
    SET_ESS_PRICE,
    SET_MADE_IN_CA,
    SET_INCLUDE_ESS,
    SET_BATTERY_TYPE,
    SET_ESS,
} from './constants';


export const setESSkW = esskW => ({
    type: SET_ESS_KW,
    esskW,
});

export const setESSkWh = esskWh => ({
    type: SET_ESS_KWH,
    esskWh,
});

export const setESSPrice = essPrice => ({
    type: SET_ESS_PRICE,
    essPrice,
});


export const setMadeInCA = madeInCA => ({
    type: SET_MADE_IN_CA,
    madeInCA,
});

export const setIncludeESS = includeESS => ({
    type: SET_INCLUDE_ESS,
    includeESS,
});

export const setBatteryType = batteryType => ({
    type: SET_BATTERY_TYPE,
    batteryType,
});
export const setESS = ess => ({
    type: SET_ESS,
    ess,
});



// WEBPACK FOOTER //
// ./src/containers/common/ess/actions.js